import React, { useEffect, useState } from "react";

import Layout from "../../components/reusable/Layout";
import Title from "../../components/reusable/Title";
import CustomCard from "../../components/reusable/CustomCard";

import Navbar from "../../components/navbar/Navbar";
import MetricsSection from "./MetricsSection";
import RiskChartBar from "../../components/reusable/RiskChartBar";

import classes from "./OverviewMetricBarGraphPage.module.css";
import CalsTable from "../CaloricBalance/CalsTable";
import FuelSources from "../CaloricBalance/FuelSources";
import { JSX } from "react";

import arrowBlueRight from "../../images/arrowBlueRight.png";
import overviewOrganSystem from "../../images/overviewOrganSystem.png";
import Xarrow, { Xwrapper } from "react-xarrows";
import { SvgConverterType } from "../../reports/Report";
import pnoeLogo from "../../images/logo.png";
import restoreLogo from "../../images/restore/restore_Logo.png";
import optimizeULogo from "../../images/optimizeU/optimizeU_Logo.png";
import xIcon from "../../images/x_Icon.png";
import dripBarLogo from "../../images/dripBar/dripBarLogo.png";

type Tab = { INDEX: number; NAME: string; VALUE: number };

type improveArea = { INDEX: number; TEXT: string; TITLE: string };

type Metric = {
  HOW_IT_IS_MEASURED: string;
  HOW_IT_IS_MEASURED_TEXT: string;
  INDEX: number;
  SUGGESTIONS: { IMPROVE_AREAS: improveArea[]; INDEX: number; TITLE: string }[];
  TITLE1: string;
  TITLE2: string;
  SUBTITLE?: string;
  TOP: string;
  VALUE: number;
  WHAT_IT_IS: string;
  WHAT_IT_IS_TEXT: string;
  WHY_ITS_IMPORTANT: string;
  WHY_ITS_IMPORTANT_TEXT: string;
  NORISK?: string;
  HIGHRISK?: string;
  METRIC_TYPE: number;
};

interface Props {
  data: {
    DESCRIPTION: null;
    INDEX: number;
    ORGANS: any;
    METRICS: Metric[];
    NAVBAR: Tab[];
    RISK_METRICS: Metric[];
    PERFORMANCE_METRICS: Metric[] | null;
    QRCODE: {
      FOOTER1: string;
      HEADER1: string;
      HEADER2: string;
      QRCODE: string;
    };

    TITLE: string;

    TITLE_PERFORMANCE_METRICS: string;
  };
  data2?: any;
  isCustomReport?: boolean;
  isEvityReport?: boolean;
  onSvgConverter: SvgConverterType;
  reportType: string;
  isCreatingPDF?: boolean;
  affiliateName?: string;
  costumerName?: string;
  testDateLabel?: string;
  testDate?: string;
  customReportType?: string;
}

const OverviewMetricBarGraphPage = React.memo(({
  data,
  data2,
  isCustomReport,
  onSvgConverter,
  reportType,
  isCreatingPDF,
  affiliateName,
  costumerName,
  testDateLabel,
  testDate,
  customReportType,
  isEvityReport,
}: Props): JSX.Element => {
  const [imgRiskBar, setImgRiskBar] = useState(false);

  useEffect(() => {
    if (data.ORGANS.CELLS.RISK_METRICS.length > 0 && !isCustomReport) {
      onSvgConverter("riskBar", "chartBarsHeader-8", 545);
      setImgRiskBar(true);
    }
  }, [onSvgConverter]);

  // Flatten METRICS from ORGANS
  const flattenedArray = Object.values(data.ORGANS).flatMap((organ: any) => [
    ...organ.METRICS,
  ]);

  // create the connection between the metrics and the organ system
  let filteredMetrics: Metric[] = [];
  if (reportType === "isAMR") {
    filteredMetrics = flattenedArray.filter(
      (metric) =>
        metric.METRIC_TYPE === 18 ||
        metric.METRIC_TYPE === 19 ||
        metric.METRIC_TYPE === 24
    );
  } else if (reportType === "isFrank_AMR") {
    filteredMetrics = flattenedArray.filter(
      (metric) => metric.METRIC_TYPE === 19 || metric.METRIC_TYPE === 24
    );
  } else {
    filteredMetrics = [
      ...flattenedArray,
      ...data.ORGANS.CELLS.RISK_METRICS,
    ].filter(
      (metric) =>
        // TODO: Need to find out what these METRIC_TYPE values are for the first two conditions
        metric.METRIC_TYPE === 8 ||
        metric.METRIC_TYPE === 19 ||
        metric.METRIC_TYPE === 24 ||
        metric.METRIC_TYPE === 25
    );
  }

  // Map the filtered array to the desired format
  const activeConnections = filteredMetrics.map((metric) => ({
    id: metric.METRIC_TYPE,
    start: `chartBarsHeader-${metric.METRIC_TYPE}`,
    end: `chartBarsHeader-${metric.METRIC_TYPE}-end`,
  }));

  const RiskBar = (
    <div id="riskBar" style={{ marginTop: "5px" }}>
      <RiskChartBar
        data={data.ORGANS.CELLS.RISK_METRICS[0]}
        onSvgConverter={onSvgConverter}
        useLargerFont={false}
      />
    </div>
  );

  return (
    <Layout dataAgentTarget={"overview_page"} isEvityReport={isEvityReport}>
      <Title dataAgentTarget={"overview_page|title"} title={data.TITLE} />
      {reportType === "isRMRCheatsheet" && (
        <div className={classes.logoContainer}>
          <img
            data-agent-target={"overview_page|pnoe_logo"}
            src={pnoeLogo}
            alt="pnoe logo"
            style={{ width: "74px" }}
          />
          <img src={xIcon} alt="pnoe logo" style={{ width: "12px" }} />
          {(customReportType === "restore" ||
            customReportType === "restore1") && (
            <img
              data-agent-target={"overview_page|company_logo"}
              src={restoreLogo}
              alt="company logo"
              style={{
                width: "74px",
              }}
            />
          )}
          {customReportType === "optimizeu" && (
            <img
              data-agent-target={"overview_page|company_logo"}
              src={optimizeULogo}
              alt="company logo"
              style={{
                width: "100px",
              }}
            />
          )}
          {customReportType === "thedripbar" && (
            <img
              data-agent-target={"overview_page|company_logo"}
              src={dripBarLogo}
              alt="company logo"
              style={{
                width: "65px",
              }}
            />
          )}
        </div>
      )}
      <Navbar data={data.NAVBAR} />
      {!isCustomReport && (
        <Xwrapper>
          <div className={classes.container}>
            <div
              className={classes.organSystemContainer}
              style={{
                borderColor:
                  reportType === "isAMR" || reportType === "isFrank_AMR"
                    ? "var(--secondary26)"
                    : "transparent",
              }}
            >
              <img
                src={overviewOrganSystem}
                style={{ width: "100%", objectFit: "contain" }}
                alt="Organ system"
              />
              {(reportType === "isAMR" || reportType === "isFrank_AMR") && (
                <img
                  src={arrowBlueRight}
                  style={{ width: "22px" }}
                  alt="connection to Organ system"
                  className={classes.organSystemContainerArrow}
                />
              )}
              <div
                className={classes.organSystemContainerLabel}
                style={{ top: "20px" }}
              >
                {data.ORGANS.BRAIN.LABELS[0]?.VALUE}
              </div>
              <div
                className={classes.organSystemContainerLabel}
                style={{ top: "225px" }}
              >
                {data.ORGANS.LUNGS.LABELS[0]?.VALUE}
              </div>
              <div
                className={classes.organSystemContainerLabel}
                style={{ top: "343px" }}
              >
                {data.ORGANS.LUNGS.LABELS[1]?.VALUE}
              </div>
              <div
                className={classes.organSystemContainerLabel}
                style={{ top: "376px" }}
              >
                {data.ORGANS.LUNGS.LABELS[2]?.VALUE}
              </div>
              <div
                className={classes.organSystemContainerLabel}
                style={{ top: "532px" }}
              >
                {data.ORGANS.HEART.LABELS[0]?.VALUE}
              </div>
              <div
                className={classes.organSystemContainerLabel}
                style={{ top: "695px" }}
              >
                {data.ORGANS.CELLS.LABELS[0]?.VALUE}
              </div>
              {/*//Dot for the line connection with metrics*/}
              {!isCreatingPDF &&
                activeConnections.find(
                  (connection) => connection.id === 24
                ) && (
                  <div
                    id="chartBarsHeader-24-end"
                    className={classes.organSystemContainerDot}
                    style={{ top: "130px", left: "133px" }}
                  />
                )}
              {!isCreatingPDF &&
                activeConnections.find(
                  (connection) => connection.id === 25
                ) && (
                  <div
                    id="chartBarsHeader-25-end"
                    className={classes.organSystemContainerDot}
                    style={{ top: "135px", left: "65px" }}
                  />
                )}
              {!isCreatingPDF &&
                activeConnections.find(
                  (connection) => connection.id === 19
                ) && (
                  <div
                    id="chartBarsHeader-19-end"
                    className={classes.organSystemContainerDot}
                    style={{ top: "400px", left: "118px" }}
                  />
                )}
              {!isCreatingPDF &&
                activeConnections.find(
                  (connection) => connection.id === 18
                ) && (
                  <div
                    id="chartBarsHeader-18-end"
                    className={classes.organSystemContainerDot}
                    style={{
                      top: "796px",
                      left: "147px",
                      backgroundColor: "transparent",
                    }}
                  />
                )}
              {!isCreatingPDF &&
                activeConnections.find((connection) => connection.id === 8) && (
                  <div
                    id="chartBarsHeader-8-end"
                    className={classes.organSystemContainerDot}
                    style={{
                      top: "796px",
                      left: "147px",
                      backgroundColor: "transparent",
                    }}
                  />
                )}
            </div>
            <div
              className={classes.metricContainer}
              data-agent-target={"overview_page|metrics_section_amr"}
            >
              {data.ORGANS.AMR.METRICS.length > 0 && (
                <div
                  className={classes.sectionContainer}
                  style={{ backgroundColor: "transparent", height: "80px" }}
                >
                  <MetricsSection
                    dataAgentTarget={"overview_page|metrics_section_amr"}
                    data={data.ORGANS.AMR.METRICS}
                    labels={data.NAVBAR.slice(0, -1)}
                  />
                </div>
              )}
              <div
                data-agent-target={"overview_page|metrics_section_brain"}
                className={classes.sectionContainer}
                style={{
                  height:
                    reportType === "isAMR" || reportType === "isFrank_AMR"
                      ? "80px"
                      : "208px",
                }}
              >
                <MetricsSection
                  dataAgentTarget={"overview_page|metrics_section_brain"}
                  data={data.ORGANS.BRAIN.METRICS}
                  labels={data.NAVBAR.slice(0, -1)}
                />
                {reportType === "isFrank_RMR" && (
                  <MetricsSection
                    dataAgentTarget={
                      "overview_page|frank_metrics_section_brain"
                    }
                    data={data.ORGANS.BRAIN.FRANK_METRICS}
                    labels={data.NAVBAR.slice(0, -1)}
                  />
                )}
              </div>
              <div
                data-agent-target={"overview_page|metrics_section_lungs"}
                className={classes.sectionContainer}
                style={{
                  height:
                    reportType === "isAMR" || reportType === "isFrank_AMR"
                      ? "348px"
                      : "311px",
                }}
              >
                <MetricsSection
                  dataAgentTarget={"overview_page|metrics_section_lungs"}
                  data={
                    reportType === "isFrank_RMR"
                      ? [
                          ...data.ORGANS.LUNGS.METRICS,
                          ...data.ORGANS.LUNGS.FRANK_METRICS,
                        ]
                      : data.ORGANS.LUNGS.METRICS
                  }
                  labels={data.NAVBAR.slice(0, -1)}
                />
              </div>
              <div
                data-agent-target={"overview_page|metrics_section_heart"}
                className={classes.sectionContainer}
                style={{
                  height:
                    reportType === "isAMR" || reportType === "isFrank_AMR"
                      ? "80px"
                      : "90px",
                }}
              >
                <MetricsSection
                  dataAgentTarget={"overview_page|metrics_section_heart"}
                  data={data.ORGANS.HEART.METRICS}
                  labels={data.NAVBAR.slice(0, -1)}
                />
              </div>
              <div
                data-agent-target={"overview_page|metrics_section_cells"}
                className={classes.sectionContainer}
                style={{
                  height:
                    reportType === "isAMR" || reportType === "isFrank_AMR"
                      ? "355px"
                      : reportType === "isRMRCheatsheet"
                      ? "290px"
                      : "320px",
                }}
              >
                <MetricsSection
                  dataAgentTarget={"overview_page|metrics_section_cells"}
                  data={
                    reportType === "isFrank_RMR" || reportType === "isFrank_AMR"
                      ? [
                          ...data.ORGANS.CELLS.METRICS,
                          ...data.ORGANS.CELLS.FRANK_METRICS,
                        ]
                      : data.ORGANS.CELLS.METRICS
                  }
                  labels={data.NAVBAR.slice(0, -1)}
                  hasGrid={reportType === "isFrank_AMR"}
                />
                {data.ORGANS.CELLS.RISK_METRICS.length > 0 && (
                  <div
                    data-agent-target={`overview_page|metrics_section_cells|metric_${data.ORGANS.CELLS.RISK_METRICS[0].TITLE1.toLowerCase().replace(
                      / /g,
                      "_"
                    )}`}
                    id="chartBarsHeader-8"
                  >
                    {!imgRiskBar && RiskBar}
                  </div>
                )}
              </div>
            </div>
          </div>
          {!isCreatingPDF &&
            activeConnections.map((connection, index) => (
              <Xarrow
                key={index}
                curveness={0}
                start={connection.start}
                end={connection.end}
                endAnchor={"middle"}
                showHead={false}
                strokeWidth={1}
                color="var(--primary400)"
              />
            ))}
        </Xwrapper>
      )}
      {isCustomReport && (
        <div>
          <MetricsSection
            data={flattenedArray}
            labels={data.NAVBAR.slice(0, -1)}
          />
          {reportType === "isRMR" && (
            <div style={{ marginTop: "40px" }}>
              <CalsTable data={data2.SECTION2} />
              <FuelSources data={data2.SECTION3} />
            </div>
          )}
        </div>
      )}
      {reportType === "isRMRCheatsheet" && (
        <div className={classes.cheatsheetContainer}>
          <div className={classes.affiliateNameValue}>{affiliateName}</div>
          <div>
            <span className={classes.testDateLabel}>{testDateLabel}: </span>
            <span className={classes.testDateValue}>{testDate}</span>
          </div>
          <div className={classes.trainerMailValue}>{costumerName}</div>
        </div>
      )}
    </Layout>
  );
});

export default OverviewMetricBarGraphPage;
